import { useEffect } from "react";
import ReactGA from "react-ga4";
import ReactPixel from "react-facebook-pixel";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import mixpanel from "mixpanel-browser";

import "./App.css";
import Questionare from "./screens/Questionare";
import { setDimensionsRatio } from "./constants/utils";
import Metrics from "./screens/Metrics";
import WelcomeScreen from "./screens/WelcomeScreen";
import Loading from "./screens/Loading";
import SignUp from "./screens/SignUp";
import DownloadApp from "./screens/DownloadApp";
import PremiumScreen from "./screens/PremiumScreen";
import ADHDApp from "./adhd_web_flow/App";
import WellbeingApp from "./measure_wellbeing/App";
import PrctnApp from "./procastination_flow/App";
import SignupOptions from "./screens/SignupOptions";
import NewOnboardingApp from "./new_onboarding/App";
import PhoneScreen from "./screens/PhoneScreen";
import Dashboard from "./screens/ProgramDashboard/ProgramDashboard";
import { ToastContainer } from "react-toastify";
import 'react-toastify/ReactToastify.css'
import HindiDashboard from "./screens/HindiPrograms/ProgramDashboard";
import ICLogin from "./screens/ICLogin/ICLogin";
import ICSignup from "./screens/ICSignup/ICSignup";
import DashboardInteractive from "./screens/DashboardInteractive/DashboardInteractive";
import { StripePaywallPre } from "./screens/PhoneScreen/stripePaywall";
import DownloadApp2 from "./screens/DownloadApp2";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { HabitChart } from "./components/HabitChart";

mixpanel.init("d28c4f6b7044ce95528e0ec2ee8f9876", {
  debug: true,
  record_sessions_percent: 100,
  record_mask_text_selector: '',
  record_block_selector: ''
})

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <WelcomeScreen />,
    },
    {
      path: "/metrics",
      element: <Metrics />,
    },
    {
      path: "/questionare",
      element: <Questionare />,
    },
    {
      path: "/signup_options",
      element: <SignupOptions/>,
    },
    {
      path: "/loading",
      element: <Loading />,
    },
    {
      path: "/premium",
      element: <PremiumScreen />,
    },
    {
      path: "/signup",
      element: <SignUp />,
    },
    {
      path: "/download",
      element: <DownloadApp />,
    },
    {
      path: "/adhd/*",
      element: <ADHDApp />,
    },
    {
      path: "/wellbeing/*",
      element: <WellbeingApp />,
    },
    {
      path: "/new_onboarding/*",
      element: <NewOnboardingApp/>,
    },
    {
      path: "/phone_screen",
      element: <PhoneScreen/>
    },
    {
      path: "/prctn/*",
      element: <PrctnApp/>
    },
    {
      path: "/dashboard",
      element: <Dashboard/> 
    },
    {
      path: "/evolve-hindi-poc",
      element: <HindiDashboard/>
    },
    {
      path: "/interactive/login",
      element: <ICLogin/>
    },
    {
      path: "/interactive/signup",
      element: <ICSignup/>
    },
    {
      path: "interactive/dashboard",
      element: <ProtectedRoute><DashboardInteractive/></ProtectedRoute>
    },
    {
      path: "/pay",
      element: <StripePaywallPre/>
    },
    {
      path: "/download2",
      element: <DownloadApp2/>
    },
    {
      path: "/habit_chart",
      element: <HabitChart/>
    }
  ]);

  useEffect(() => {
    setDimensionsRatio();

    ReactPixel.init(
      "2763359800559914",
      {},
      {
        autoConfig: true,
        debug: false,
      }
    );
    ReactGA.initialize("G-FNZK4CF0YD");
    
  }, []);

  const queryParams = new URLSearchParams(window.location.search);
  const isRenderMode = queryParams.get('render') === 'chart';

  if (isRenderMode) {
    const activityData = window.reportData;
    if (!activityData) return <div>WAITING FOR REPORT DATA...</div>;
    return (
      <div id="render-root">
        <HabitChart data={activityData} />
      </div>
    );
  }

  return (
    <div className="App">
      <ToastContainer position="top-right" autoClose={3000}/>
      <GoogleOAuthProvider clientId="641054470672-1ko0sj314a3nhlm7qmoivar1k1jpqi3f.apps.googleusercontent.com" >
      <RouterProvider router={router} />
      </GoogleOAuthProvider>
    </div>
  );
}

export default App;
